interface ApiError {
  response?: {
    data?: {
      errors?: string;
      message?: string;
    };
  };
}

export const getErrorMessage = (error: unknown): string => {
  const apiError = error as ApiError;

  return (
    apiError.response?.data?.errors ||
    apiError.response?.data?.message ||
    "An unexpected error occurred. Please try again."
  );
};
